import { TBrand as TOneSearchBrand, TOneSearchClassEnums } from './OneSearchHelper';

export const OneSearchBrandMap = {
  'Mercedes-Benz': 'Mercedes-Benz' as const,
  MERCEDES_BENZ: 'Mercedes-Benz' as const,
  'Mercedes-Maybach': 'Mercedes-Maybach' as const,
  MERCEDES_MAYBACH: 'Mercedes-Maybach' as const,
  'Mercedes-AMG': 'Mercedes-AMG' as const,
  MERCEDES_AMG: 'Mercedes-AMG' as const,
};

type OneSearchBrandToModelMap = {
  [K in TOneSearchBrand]: {
    [side in 'LEFT' | 'CENTER' | 'RIGHT']: TOneSearchClassEnums[];
  };
};

export const oneSearchBrandToModelMap: OneSearchBrandToModelMap = {
  MERCEDES_BENZ: {
    LEFT: ['A', 'B', 'CLA', 'GLA', 'GLB', 'EQA', 'EQB'], //EQT not available as filter => removed,
    CENTER: ['C', 'GLC', 'E', 'CLE', 'V', 'EQV'],
    RIGHT: ['GLE', 'EQE', 'EQS', 'GLS', 'G', 'S'],
  },
  MERCEDES_AMG: {
    LEFT: ['A', 'CLA'],
    CENTER: ['C', 'GLC', 'E', 'EQE'],
    RIGHT: ['GLE', 'EQS', 'GLS', 'G', 'S', 'SL'], //GT not available as filter => removed
  },
  MERCEDES_MAYBACH: {
    LEFT: ['GLS'],
    CENTER: ['S'],
    RIGHT: ['EQS'],
  },
  get 'Mercedes-Benz'() {
    return oneSearchBrandToModelMap.MERCEDES_BENZ;
  },
  get 'Mercedes-AMG'() {
    return oneSearchBrandToModelMap.MERCEDES_AMG;
  },
  get 'Mercedes-Maybach'() {
    return oneSearchBrandToModelMap.MERCEDES_MAYBACH;
  },
};
